import React, { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { colors } from '../../../constants'
import { mediaQuery, mediaQueryForBigger } from '../../utils'

const Label = styled.span`
    color: ${colors.greylighter};
`

const DateOption = styled.a`
    color: ${colors.greylighter};
    cursor: pointer;
    text-transform: uppercase;

    ${({ selected }) =>
        selected &&
        `
      color: ${colors.orange};
      font-weight: bold;
    `}

    ${mediaQueryForBigger.mobile(`
    font-size: 14px;
    padding: 14px;
  `)}

  ${mediaQuery.mobile(`
    font-size: 12px;
    padding: 0px 5px;
    display: inline-block;
    &:first-child {
      padding-left: 0px;
    }
  `)}
`

class DateSelector extends PureComponent {
    static propTypes = {
        labels: PropTypes.arrayOf(PropTypes.string),
        onChange: PropTypes.func,
        selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    }

    static defaultProps = {
        labels: [],
        onChange: () => null,
        selected: null,
        values: [],
    }

    onClickOption(value) {
        const { onChange } = this.props
        this.setState({}, () => onChange(value))
    }

    render() {
        const { labels, selected, values } = this.props

        return (
            <Fragment>
                {values.map((value, index) => (
                    <Fragment key={value}>
                        <DateOption onClick={() => this.onClickOption(value)} selected={value === selected}>
                            {labels[index]}
                        </DateOption>
                        {index < values.length - 1 ? <Label>/</Label> : null}
                    </Fragment>
                ))}
            </Fragment>
        )
    }
}

export default DateSelector
